/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import { apinoticelist } from '@/api';
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
// import CheckUser from '@/components/CheckUser'
export default {
  name: 'noticeList',
  data: function data() {
    return {
      pageIndex: 0,
      pageSize: 10,
      List: []
    };
  },
  components: {
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    Group: Group,
    ViewBox: ViewBox
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      return document.documentElement.clientHeight;
    }
  },
  methods: {
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      var _this = this;
      this.pageIndex = 0;
      this.loadList(true).then(function (res) {
        _this.$refs['noticeList'].donePulldown();
      });
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      var _this2 = this;
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {
        _this2.$refs['noticeList'].donePullup();
      });
    },
    // 初始化企业公告加载
    loadList: function loadList() {
      var _this3 = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
      }
      return new Promise(function (resolve, reject) {
        var data = {
          pageIndex: _this3.pageIndex,
          pageSize: _this3.pageSize
        };
        apinoticelist(data).then(function (res) {
          if (!reset) {
            _this3.List = [].concat(_toConsumableArray(_this3.List), _toConsumableArray(res.data));
          } else {
            _this3.List = res.data;
            setTimeout(function () {
              _this3.$vux.loading.hide();
            }, 300);
          }
          resolve();
          // 判断是否有新数据
          if (res.data.length < _this3.pageSize) {
            _this3.$refs['noticeList'] && _this3.$refs['noticeList'].disablePullup();
          }
          if (res.data.length === _this3.pageSize) {
            _this3.$refs['noticeList'] && _this3.$refs['noticeList'].enablePullup();
          }
        });
      });
    }
  },
  created: function created() {
    this.loadList();
  }
};